'use strict';

exports.__esModule = true;
exports['default'] = parser;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _remarkable = require('remarkable');

var _remarkable2 = _interopRequireDefault(_remarkable);

var _highlightJs = require('highlight.js');

var _highlightJs2 = _interopRequireDefault(_highlightJs);

var remarkableInstance = new _remarkable2['default']({
  highlight: function highlight(str) {
    try {
      return _highlightJs2['default'].highlight('javascript', str).value;
    } catch (err) {
      console.log(err);
    }
  }
});

function decorateString(str) {
  return '```\n' + str + '```';
}

function renderFromMarkdown(md) {
  return remarkableInstance.render(md);
}

function parser(str) {
  return renderFromMarkdown(decorateString(str)).trim();
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-embed-code/lib/utils/parser.js
// module id = oCef
// module chunks = 0